export type Interface<T> = {
  [P in keyof T]: T[P];
};

export type Coordinates = {
  latitude: number;
  longitude: number;
};

export const isNotUndefined = <T>(item: T | undefined): item is T =>
  item !== undefined;

export const isNullOrUndefined = (
  value: unknown,
): value is null | undefined => value === null || value === undefined;
